export default ({ data, productNames, statusColors, statuses }) => {
  const newData = {
    labels: transformProductNames(productNames),
    datasets: statuses.map((status, index) => {
      const color = colors[index]
      const dataset = {
        backgroundColor: `rgba(${color[0]},${color[1]},${color[2]},0.9)`,
        borderColor: 'rgba(220,220,220,0.8)',
        borderWidth: 1,
        hoverBackgroundColor: `rgba(${color[0]},${color[1]},${color[2]},1)`,
        hoverBorderColor: 'rgba(220,220,220,1)'
      }
      dataset.label = status
      dataset.data = data[index]

      return dataset
    })
  }

  return newData
}

const colors = [
  [76, 132, 255],
  [116, 172, 246],
  [132, 185, 255],
  [178, 209, 249]
]

const transformProductNames = (names) =>
  names.map((name) => {
    const _name = namesLibrary[name] || name

    return _name.split(' ')
  })

const namesLibrary = {
  Starbucks3700: 'Starbucks 3700',
  StarbucksSimphony: 'Starbucks Simphony'
}
